import React from 'react';
import { RedocStandalone } from 'redoc';

import playapiOutDocs from './playapiOutDocs.json';

function PlayapiDocs() {
    return (
        <div>
            <RedocStandalone spec={playapiOutDocs} options={{ scrollYOffset: 100 }} />
        </div>
    );
}

export default PlayapiDocs;
